<template>
  <div class='container'>
    <div class="draw-top"></div>
    <div class="draw-box">
      <div class="draw-turntable">
        <turn-table
          :loading-finished="loadFinished"
          :prize-number="prizeNumber"
          :before-luck-draw="beforeLuckDraw"
          @luckDrawFinshed="luckDrawFinshed">
        </turn-table>
      </div>
    </div>
  </div>
</template>

<script>
import TurnTable from './children/TurnTable'
import { MessageBox, Toast } from 'mint-ui'
import { GetFreeCard } from '@/api/evaluate'

export default {
  data () {
    return {
      orderNumber: '',
      loadFinished: false,
      // 中奖位置
      prizeNumber: 0
    }
  },
  components: {
    TurnTable
  },
  mounted () {
    this.orderNumber = this.$route.query.orderNum ? this.$route.query.orderNum : ''
    if (!this.orderNumber) {
      Toast('无订单号')
      this.$router.go(-1)
    }
  },
  methods: {
    // 开始抽奖之前请求数据
    beforeLuckDraw (resolve, reject) {
      this.loadFinished = false
      GetFreeCard({ orderNo: this.orderNumber }).then(res => {
        this.prizeNumber = (parseInt(res.Data) - 1) || 0
        this.loadFinished = true
        resolve()
      }).catch(err => {
        this.loadFinished = true
        Toast(err.ErrMsg)
        reject()
      })
    },
    // 抽奖结束
    luckDrawFinshed () {
      this.loadFinished = false
      MessageBox({
        title: '提示',
        message: `恭喜你抽到免单卡${this.prizeNumber + 1}张`,
        showCancelButton: false,
        closeOnClickModal: false,
        confirmButtonText: '去使用',
        confirmButtonClass: 't_f23030'
      }).then(action => {
        if (action === 'confirm') {
          this.$router.replace({
            name: 'zeroBuyMain'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .container{
    background: #d8043d;
    font-size: 12px;
  }
  .draw-top{
    width: 100%;
    height: 300px;
    background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20190111/5255383840403995868.png') no-repeat;
    background-size: 100% 272%;
    background-position: 0 0;
  }
  .draw-box{
    width: 90%;
    height: 277px;
    margin: 0px auto;
    padding: 20px 20px;
    box-sizing: border-box;
    box-shadow: 0 0 35px 10px #cb033b;
    background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20190111/5255383840403995868.png') no-repeat;
    background-size: 112% 263%;
    background-position: 53% 100%;
  }
  .draw-turntable{
    width: 100%;
    height: 100%;
  }
  @media screen and (max-height: 568px){
  .draw-top{
    height: 250px;
  }
}
</style>
